module.exports = __webpack_public_path__ + "static/media/styledmenu-arrow-down-heading-color.eebc0c4b.svg";